import { Injectable } from '@angular/core';
import { PalantirIcon } from '@flux/design-system';
import { FeatureFlagsEnum } from '@generated/featureFlags.enum';
import { GlobalPermissionsEnum } from '@generated/permissions.enum';

export interface NavigationItem {
  url: string;
  icon: PalantirIcon;
  label: string;
  alignSelf?: 'top' | 'bottom';
  has_feature_flag?: `${FeatureFlagsEnum}`[] | FeatureFlagsEnum[];
  required_permissions?: GlobalPermissionsEnum[] | `${GlobalPermissionsEnum}`[];
}

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  private navigations: NavigationItem[] = [
    {
      label: 'Meu espaço',
      url: 'meu-espaco',
      icon: 'home-filled',
      alignSelf: 'top',
    },
    {
      label: 'Fluxos de trabalho',
      url: 'fluxos',
      icon: 'add-widgets-outline',
      alignSelf: 'top',
      required_permissions: ['global:pipes:read_all', 'global:pipes:read_limited'],
    },
    {
      label: 'Notificações',
      url: 'notificacoes',
      icon: 'notifications-outline',
      alignSelf: 'top',
    },
    {
      label: 'Ajustes da conta',
      url: 'perfil',
      icon: 'settings-outline',
      alignSelf: 'top',
    },
    {
      label: 'Banco de dados',
      url: 'banco-de-dados',
      icon: 'database-outline',
      alignSelf: 'top',
      has_feature_flag: ['feature:database'],
      required_permissions: ['global:database:read_all', 'global:database:read_limited'],
    },
    {
      label: 'Configurações - Papeis',
      url: 'gerenciar/papeis',
      icon: 'settings-outline',
      alignSelf: 'bottom',
      required_permissions: ['global:roles:manage_permissions'],
    },
    {
      label: 'Configurações - Pessoas',
      url: 'gerenciar/pessoas',
      icon: 'settings-outline',
      alignSelf: 'bottom',
      required_permissions: ['global:roles:manage_users'],
    },
    {
      label: 'Configurações - Faturamento',
      url: 'gerenciar/faturamento',
      icon: 'settings-outline',
      alignSelf: 'bottom',
      required_permissions: ['global:features:manage'],
    },
  ];

  getNavigationItems(): NavigationItem[] {
    return this.navigations as NavigationItem[];
  }
}
